import { render } from "./ChooseAvatar.vue?vue&type=template&id=1fb012e6&scoped=true"
import script from "./ChooseAvatar.vue?vue&type=script&lang=js"
export * from "./ChooseAvatar.vue?vue&type=script&lang=js"

import "./ChooseAvatar.vue?vue&type=style&index=0&id=1fb012e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb012e6"],['__file',"src/components/start/ChooseAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fb012e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fb012e6', __exports__)) {
    api.reload('1fb012e6', __exports__)
  }
  
  module.hot.accept("./ChooseAvatar.vue?vue&type=template&id=1fb012e6&scoped=true", () => {
    api.rerender('1fb012e6', render)
  })

}


export default __exports__